<template>

    <AppLoader></AppLoader>

    <div class="appView" v-if="appReady">

        <StaffChatBanner v-if="isStaffUser"></StaffChatBanner>

        <CommunityButton  v-if="user.publisherLevelId < 2"></CommunityButton>

        <ErrorAlert></ErrorAlert>

        <StartChat 
            v-if="view === 'startChat'" 
            @chat-created="openChatInterface"
        ></StartChat>

        <ChatInterface 
            v-if="view === 'chatInterface'" 
            @chat-closed="resetApp"
        ></ChatInterface>

    </div>
    
</template>

<script>
    import AppLoader from '@/components/apploader.vue';
    import ErrorAlert from '@/components/erroralert.vue';
    import StartChat from '@/views/startchat/index.vue';
    import ChatInterface from '@/views/chat/index.vue';
    import StaffChatBanner from '@/components/staffchatbanner.vue';
    import CommunityButton from '@/components/communitybutton.vue';

    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'App',
        components: {
            AppLoader,
            ErrorAlert,
            StartChat,
            ChatInterface,
            StaffChatBanner,
            CommunityButton,
        },
        data() {
            return {
                showLoader: false,
                userAuthenticated: false,
                checkedExistingChat: false,
                isStaffUser: false,
            };
        },
        async beforeMount() {
            this.incrementAppLoader();

            await this.authenticateAppUser();
            await this.fetchExistingChat();

            this.decrementAppLoader();
        },
        computed: {
            ...mapGetters([
                "view",
                "user", 
                "currentChatLoaded",
                "currentChat",
            ]),
            appReady() {
                return this.userAuthenticated && this.checkedExistingChat;
            }, 
        },
        methods: {
            ...mapActions([
                "incrementAppLoader",
                "decrementAppLoader",
                "getUser", 
                "getChat", 
                "setView", 
                "resetApp",
                "setIsMockPublisherChat",
            ]),
            async authenticateAppUser() {
                await this.getUser();

                if (this.user.isLoaded) {
                    this.userAuthenticated = true;

                    if (this.user.userType === "contributor") {
                        this.isStaffUser = true;
                    }
                }
            },
            async fetchExistingChat() {
                const cookieChatId = this.$cookies.get('qabotChatId');
                if (!cookieChatId) {
                    this.checkedExistingChat = true;
                    return;
                }

                const getChatInput = {
                    "chatId": parseInt(cookieChatId),
                };

                await this.getChat(getChatInput);

                this.checkedExistingChat = true;

                if (this.currentChat.isLoaded) {
                    this.openChatInterface();

                    if (this.user.userType === "contributor" && this.currentChat.publisherId > 0) {
                        this.setIsMockPublisherChat(true);
                    }
                }
            },
            openChatInterface() {
                this.setView(this.$const.APP_VIEW__CHAT_INTERFACE);
            },
        },
    }
</script>
<style scoped>

.appView {
    height: 100%;
}
</style>